import React from "react";

const ContactSection = () => {
  return (
    <section className="contact-section" style={{ padding: "4rem 2rem", maxWidth: "1000px", margin: "0 auto" }}>
      <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>Contact Us</h2>
      <p style={{ marginBottom: "2rem", color: "#555" }}>
        Have a question, feedback, or just want to say hello? We’d love to hear from you!
      </p>

      <form
        className="contact-form"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          background: "#fff",
          borderRadius: "10px"
        }}
      >
        <input
          type="text"
          placeholder="Your Name"
          required
          style={{
            padding: "0.75rem",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1rem",
          }}
        />
        <input
          type="email"
          placeholder="Your Email"
          required
          style={{
            padding: "0.75rem",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1rem",
          }}
        />
        <textarea
          placeholder="Your Message"
          rows="5"
          required
          style={{
            padding: "0.75rem",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            resize: "vertical",
          }}
        ></textarea>
        <button
          type="submit"
          style={{
            backgroundColor: "#f9435f",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.5rem",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "1rem",
          }}
        >
          Send Message
        </button>
      </form>
    </section>
  );
};

export default ContactSection;
